module.exports = __webpack_public_path__ + "img/abinoid-cbd-salve.25ce566f.jpg";